<div class="demo">
  <ul class="progress-tracker anim-ripple">
    <li
      class="progress-step active"
      *ngFor="let status of defaultFlow; let i = index"
      [ngClass]="{
        's-cancelled': status?.data?.toStatus === 'CANCELLED',
        's-hold': status?.data?.toStatus === 'HOLD',
        active: status?.data?.id != null
      }"
    >
      <span class="progress-marker">
        <h6>{{ status.text }}</h6>
        <div class="additional-data" *ngIf="status?.data?.id != null">
          {{ status?.data?.changedByName }}<br />
          <div class="date-time">
            <ion-icon name="alarm" mode="ios"></ion-icon
            >{{ status?.data?.changedDate | date: "hh:mm a, dd-MMM" }}
          </div>
        </div>
      </span>
    </li>
  </ul>
</div>
